// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F7pS","option":"styles_option__2DzaX","active":"styles_active__Fh61c"};